import React, { useState } from 'react';
import { useEffect } from 'react';
import './Nav.css';

const Nav = () => {
    const [show,handleShow]=useState(false);

    useEffect(()=>{

        window.addEventListener('scroll',()=>{
            if(window.scrollY>100){
                handleShow(true)
            }
            else handleShow(false);
        });

        return ()=>{
            window.removeEventListener('scroll');
        }
    },[])

    return (
        <div className={`nav ${show?'show':''}`}>
            <img src="https://www.freepnglogos.com/uploads/red-netflix-logo-text-png-3.png" alt="Netflix Logo" className="nav__logo"/>
            <img src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/batman_hero_avatar_comics-512.png" alt="avatar picture" className='nav__avatar'/>

        </div>
    )
}

export default Nav
